export const QUERY_KEYS = {
  JOBS: 'jobs',
  JOB_ORGANIZATIONS: 'jobOrganizations',
  USERS: 'users',
  ORGANIZATIONS: 'organizations',
  ORGANIZATION: 'organization',
  ORGANIZATION_NAMES: 'organizationNames',
  ASSIGNABLE_USERS: 'assignableUsers',
  ORGANIZATION_NAVIGATION_INFO: 'organizationNavigationInfo',
  ORGANIZATION_CONFIGURATION: 'organizationConfiguration',
  ORGANIZATION_IMPLEMENTATION_TYPE: 'organizationImplementationType',
  CLIENT_CONFIGURATIONS: 'clientConfigurations',
  GRAPH_LIBRARY_VERSIONING: 'graphLibraryVersioning',
  ORGANIZATION_GRAPH_LIBRARY_VERSIONING: 'organizationGraphLibraryVersioning',
  CLIENT_INFOS: 'clientInfos',
  CLIENT_INFOS_FOR_DISCOVERY: 'clientInfosForDiscovery',
  SERVICE_VERSIONS: 'serviceVersions',
  DROPBOX_REFRESH_TOKENS: 'dropboxRefreshTokens',
  MICROSOFT_REFRESH_TOKENS: 'microsoftRefreshTokens',
  SHAREPOINT_APPS: 'sharepointApps',
  AUDIT_LOGS: 'auditLogs',

  CASES: 'cases',
  CASE: 'case',
  CASES_DELETION_STATUS: 'casesDeletionStatus',
  CASE_FILES: 'caseFiles',
  CASE_FILES_FILTERS: 'caseFilesFilters',
  EXPORT_CASES: 'exportCasesToCsv',
  EXPORT_CASE_FILES: 'exportCaseFilesToCsv',
  DELETE_CASE_FILES: 'deleteCaseFiles',
  CASE_EMPTY_FOLDERS: 'caseEmptyFolders',

  INTAKES: 'intakes',
  INTAKE: 'intake',
  INTAKES_DELETION_STATUS: 'intakesDeletionStatus',
  INTAKE_FILES: 'intakeFiles',
  INTAKE_FILES_FILTERS: 'intakeFilesFilters',
  EXPORT_INTAKES: 'exportIntakesToCsv',
  EXPORT_INTAKE_FILES: 'exportIntakeFilesToCsv',
  DELETE_INTAKE_FILES: 'deleteIntakeFiles',
  INTAKE_EMPTY_FOLDERS: 'intakeEmptyFolders',

  PROVIDERS: 'providers',
  PROVIDER: 'provider',
  PROVIDERS_DELETION_STATUS: 'providersDeletionStatus',
  PROVIDER_FILES: 'providerFiles',
  EXPORT_PROVIDERS: 'exportProvidersToCsv',
  EXPORT_PROVIDER_FILES: 'exportProviderFilesToCsv',
  DELETE_PROVIDER_FILES: 'deleteProviderFiles',
  PROVIDER_EMPTY_FOLDERS: 'providerEmptyFolders',

  TEMPLATES: 'templates',
  TEMPLATE: 'template',
  TEMPLATES_DELETION_STATUS: 'templatesDeletionStatus',
  TEMPLATE_FILES: 'templateFiles',
  EXPORT_TEMPLATES: 'exportTemplatesToCsv',
  EXPORT_TEMPLATE_FILES: 'exportTemplateFilesToCsv',
  DELETE_TEMPLATE_FILES: 'deleteTemplateFiles',
  TEMPLATE_EMPTY_FOLDERS: 'templateEmptyFolders',

  FIRM_DOCUMENTS_FOLDERS: 'firmDocumentsFolders',
  FIRM_DOCUMENTS_FOLDER: 'firmDocumentsFolder',
  FIRM_DOCUMENTS_FOLDER_DELETION_STATUS: 'firmDocumentsFoldersDeletionStatus',
  FIRM_DOCUMENTS: 'firmDocuments',
  EXPORT_FIRM_DOCUMENTS_FOLDERS: 'exportFirmDocumentsFoldersToCsv',
  EXPORT_FIRM_DOCUMENTS: 'exportFirmDocumentsToCsv',
  DELETE_FIRM_DOCUMENTS: 'deleteFirmDocuments',
  FIRM_DOCUMENTS_FOLDER_EMPTY_FOLDERS: 'FirmDocumentsFolderEmptyFolders',
  
  FLAGGED_PATHS: 'flaggedPaths',
  EXPORT_FLAGGED_PATHS: 'exportFlaggedPaths',
  FLAGGED_PATH_OCCURRENCES: 'flaggedPathOccurrences',

  SQL_SCRIPT_JOBS: 'sqlScriptJobs',
  BULK_DELETION_JOBS: 'bulkDeletionJobs',
  MIGRATION_QUEUE_STATUS: 'migrationQueueStatus',

  CASE_CONFLICT_GROUPS: 'caseConflictGroups',
  INTAKE_CONFLICT_GROUPS: 'intakeConflictGroups',
  PROVIDER_CONFLICT_GROUPS: 'providerConflictGroups',
  TEMPLATE_CONFLICT_GROUPS: 'templateConflictGroups',
  FIRM_DOCUMENTS_CONFLICT_GROUPS: 'firmDocumentsConflictGroups',
  ORG_CONFLICT_PREFLIGHT: 'orgConflictPreflight',
  ORG_CONFLICT_RESOLVED_FILES: 'orgConflictResolvedFiles',
  ORG_NOT_FOUND_RETRY_COUNTS: 'orgNotFoundRetryCounts',
  ORG_FLAG_COUNTS: 'orgFlagCounts',
  DELETION_REQUEST_TARGETS: 'deletionRequestTargets',
  PATH_COLLISION_RECONCILE_FILES: 'pathCollisionReconcileFiles',
  // The rule vocabulary and the shared library are the same in every organization, so neither carries one.
  CONFLICT_RULE_CATALOG: 'conflictRuleCatalog',
  CONFLICT_RULE_LIBRARY: 'conflictRuleLibrary',
  CONFLICT_RULE_RUN_GROUPS: 'conflictRuleRunGroups',
  RULE_CASE_SEARCH: 'ruleCaseSearch',

  CLIENT_IDS: 'clientIds',
  CASE_CYCLES: 'caseCycles',
  INTAKE_CYCLES: 'intakeCycles',
  PROVIDER_CYCLES: 'providerCycles',
  FIRM_DOCUMENT_CYCLES: 'firmDocumentCycles',
  TEMPLATE_CYCLES: 'templateCycles',

  RENAMED_FOLDER_FINDINGS: 'renamedFolderFindings',
  SHADOW_FOLDER_FINDINGS: 'shadowFolderFindings',
  SOURCE_LINKS: 'sourceLinks',
  SOURCE_LINK_SUMMARY: 'sourceLinkSummary',
  SOURCE_LINK_FILES: 'sourceLinkFiles',
  SOURCE_LINK_EXPORTS: 'sourceLinkExports',
  CONFIGURED_SOURCE_ROOTS: 'configuredSourceRoots',

  DOCS_MANIFEST: 'docsManifest',
  DOCS_PAGE: 'docsPage',
  DOCS_SEARCH_INDEX: 'docsSearchIndex',
  CHANGELOG: 'changelog',
} as const;